import clsx from 'clsx';
import slugify from 'slugify';

type PickerItemProps = {
  rounded?: boolean;
  color?: string;
  selected?: boolean;
  onClick?: () => void;
};

export const PickerItem = ({ color, rounded = false, selected = false, onClick }: PickerItemProps) => {
  const isDefault = !color;

  const clsContainer = clsx(
    'icon-library--colorpicker-item',
    `colorpicker-item--${slugify(color || 'default')}`,
    'flex items-center justify-center border bg-gray p-px m-1 overflow-hidden relative cursor-pointer animate-fade',
    isDefault ? 'border-dashed' : 'border-solid',
    selected ? 'border-black' : 'border-gray',
    rounded && 'rounded-full',
  );
  const clsFill = clsx('h-4 w-4 m-px', rounded && 'rounded-full');

  return (
    <div className={clsContainer} onClick={onClick}>
      <div className={clsFill} style={{ backgroundColor: color }}>
        {isDefault && (
          <svg
            fill="none"
            viewBox="0 0 24 24"
            stroke="red"
            strokeWidth="2"
            strokeLinecap="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line x1="23" y1="1" x2="1" y2="23"></line>
          </svg>
        )}
      </div>
    </div>
  );
};
